import { FC, useContext, useEffect, useRef } from "react";
import NotificationDispatch, { showErrorNotification } from "../../../../../context/notificationContext";
import useI18n from "../../../../../hooks/useTranslations";
import { useTerminalsApi } from "../../../../../http/patrol/useTerminals";
import FlexContent from "../../../../ui/FlexContent";
import TerminalForm from "./TerminalForm";

interface EditTerminalProps {
  onClose: () => void;
  terminalId: string;
}

const EditTerminal: FC<EditTerminalProps> = ({ onClose, terminalId }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const aborter = useRef(new AbortController());
  const terminalApi = useTerminalsApi();

  const { data, error, trigger } = terminalApi.getAdminTerminal(aborter.current.signal);

  useEffect(() => {
    error && dispatch(showErrorNotification(i18n, error));
  }, [error]);

  useEffect(() => {
    terminalId && trigger(terminalId);
  }, [terminalId]);

  return (
    <FlexContent direction="row">
      <TerminalForm onClose={onClose} terminal={data} isDisabled={!!error} isLoading={!data && !error} />
    </FlexContent>
  );
};

export default EditTerminal;
